/*
  GROOVI hero image fade — LCP-safe via overlay approach.

  The image renders at opacity:1 from frame one (LCP-eligible per Chrome's
  algorithm). A ::before overlay on the section starts at opacity:1
  covering it; we add .is-loaded to the section the moment the first <img>
  inside finishes loading, which fades the overlay out and reveals the
  image gracefully.

  Why not opacity-on-img: setting opacity:0 on the LCP image disqualifies
  it from being painted per Chrome's LCP algorithm, dragging render delay
  up by ~230 ms on every load. The overlay approach has zero LCP impact —
  pseudo-elements with only background-color are not LCP candidates.

  Multiple <img> elements per section: Horizon's responsive heroes render
  desktop and mobile variants as separate <img> tags shown/hidden via CSS.
  We reveal as soon as ANY image inside fires load — the visible variant
  wins its size class and we don't block on the off-screen one.

  Scope: hero-only. No IntersectionObserver, no transforms, no scroll
  coupling.
*/
(function () {
  'use strict';

  function reveal(section) {
    requestAnimationFrame(function () {
      section.classList.add('is-loaded');
    });
  }

  document.querySelectorAll('[data-groovi-hero]').forEach(function (section) {
    var imgs = section.querySelectorAll('img');
    if (!imgs.length) {
      reveal(section);
      return;
    }

    var revealed = false;
    function tryReveal() {
      if (revealed) return;
      revealed = true;
      reveal(section);
    }

    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        tryReveal();
      } else {
        img.addEventListener('load', tryReveal, { once: true });
        img.addEventListener('error', tryReveal, { once: true });
      }
    });
  });
}());
